var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNavi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 12.25C3.69832 12.25 2.91666 13.0317 2.91666 14C2.91666 14.9683 3.69832 15.75 4.66666 15.75C5.63499 15.75 6.41666 14.9683 6.41666 14C6.41666 13.0317 5.63499 12.25 4.66666 12.25ZM4.66666 5.25C3.69832 5.25 2.91666 6.03167 2.91666 7C2.91666 7.96833 3.69832 8.75 4.66666 8.75C5.63499 8.75 6.41666 7.96833 6.41666 7C6.41666 6.03167 5.63499 5.25 4.66666 5.25ZM4.66666 19.25C3.69832 19.25 2.91666 20.0433 2.91666 21C2.91666 21.9567 3.70999 22.75 4.66666 22.75C5.62332 22.75 6.41666 21.9567 6.41666 21C6.41666 20.0433 5.63499 19.25 4.66666 19.25ZM8.16666 22.1667H24.5V19.8333H8.16666V22.1667ZM8.16666 15.1667H24.5V12.8333H8.16666V15.1667ZM8.16666 5.83333V8.16667H24.5V5.83333H8.16666Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavi);
export default __webpack_public_path__ + "static/media/ic-navi.28a62c2128395e727940b564495412db.svg";
export { ForwardRef as ReactComponent };